import { tokens } from '@servicetitan/tokens/core';
import { inboxLocators } from '@locators/inbox';
import {
  StatusColorMapping,
  LabelColorMapping,
  AddressVerificationStatuses,
} from './AddressVerificationDefinitions';
import SuggestedAddress from '../SuggestedAddress';
import { useState } from 'react';
import StatusLight from '@components/StatusLight/StatusLight';
import { Icon, Stack, Tooltip } from '@servicetitan/design-system';
import strings from './strings';
import useAddressFormManagerContext from '../../context/useAddressFormManagerContext';
import getAddressVerificationStatus from './getAddressVerificationStatus';

const AddressVerificationStatus = () => {
  const [showSuggestedAddress, setShowSuggestedAddress] = useState(false);
  const {
    isSuggestedAddressUsed,
    loadingSuggestedAddresses,
    suggestedAddresses,
  } = useAddressFormManagerContext();

  const addressVerificationStatus = getAddressVerificationStatus(
    isSuggestedAddressUsed,
    !loadingSuggestedAddresses && suggestedAddresses.length === 0,
  );

  return (
    <Stack spacing={0}>
      <SuggestedAddress
        open={showSuggestedAddress}
        popoverTrigger={
          <StatusLight
            id={
              inboxLocators.customerSearch.createFormFields.address
                .verifyAddressLabels[addressVerificationStatus]
            }
            onClick={
              addressVerificationStatus ===
              AddressVerificationStatuses.NOT_VERIFIED
                ? () => setShowSuggestedAddress(true)
                : undefined
            }
            color={StatusColorMapping[addressVerificationStatus]}
          >
            {LabelColorMapping[addressVerificationStatus]}
          </StatusLight>
        }
        hideSuggestedAddress={() => setShowSuggestedAddress(false)}
      />
      <Tooltip direction='top' text={strings.labels.tooltip}>
        <Icon name='help' color={tokens.colorNeutral100} />
      </Tooltip>
    </Stack>
  );
};

export default AddressVerificationStatus;
